import React , {useEffect,useState}from 'react';
import { Link,useParams} from "react-router-dom";  
import { getAdminApplicantsList } from '../../Service';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faArrowLeftLong} from '@fortawesome/free-solid-svg-icons';

export default function EventApplication(){ 
  let params = useParams();
  const [adminApplicationData, setAdminApplicationData] = useState({});

  useEffect(() => {
    let paramsDt = { 'exhibitor_id': params.id};
    getAdminApplicantsList(paramsDt).then(res => handleResponse(res))
  }, []);

  const handleResponse = (response) => {
    
    if(response.data.code==200){  
      setAdminApplicationData(response.data.data);
    } else { 
        const errors = {};
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.message,
        })
    } 
}

const handleClick = (res) => {
  window.open(res, '_blank');
}
  
  return(
  <>
  <section className="sec-container" > 
    <div className='container'>
      <div className='dashboard'>
        <div className='dashboard-row'>
          <div className='row'>
          <div className='col-md-5'> 
          <Link to={ `/view_application/${adminApplicationData.event_id}` }><FontAwesomeIcon icon={faArrowLeftLong} /> </Link>
          </div>
            <div className='col-md-7'> 
              <h1 style={{"text-align":"Left"}}>{adminApplicationData.event_name}</h1>
            </div>
          </div> 
          <div className='row'>
            <div className='col-md-6'> 
              <div className='dash-box-left'>

                <div>
                  <h2>Gallery Name</h2>
                  <p>{adminApplicationData.gallery_name}</p>
                  <hr/>
                </div>

                <div>
                  <h2>Address</h2>
                  <p>{adminApplicationData.address1} {adminApplicationData.address2!='' ? ','+adminApplicationData.address2:''}<br/>
                  {adminApplicationData.city}, {adminApplicationData.state}<br/>
                  {adminApplicationData.country}</p>
                  <hr/>
                </div>

                <div>
                  <h2>Telephone</h2>
                  <p>{adminApplicationData.phone}</p>
                  <hr/>
                </div>

                <div>
                  <h2>Website</h2>
                  { adminApplicationData.website!=='' ? <a href={adminApplicationData.website} target="_blank">{adminApplicationData.website}</a> : ''}
                  <hr/>
                </div>

                <div>
                  <h2>Primary Contact</h2>
                  <p>{adminApplicationData.primary_contact_full_name}  (billing only) -</p>
                  <a href={`mailto:${adminApplicationData.billing_email}`}  target="_blank">{adminApplicationData.billing_email}</a>
                  <hr/>
                </div>

                <div>
                  <h2>Billing Email</h2>
                  <a href={`mailto:${adminApplicationData.billing_email}`} target="_blank">{adminApplicationData.billing_email}</a>
                </div>
              </div>
            </div>
            <div className='col-md-6 dash-box-right'> 
              <div>
                <h2>Status</h2>
                <p>{adminApplicationData.event_status ? adminApplicationData.event_status==='pending' ? 'Pending' : adminApplicationData.event_status==='approve' ? 'Approved' : adminApplicationData.event_status==='reject' ? 'Rejected':'' :'Application In Progress'}</p>
                <hr/>
              </div>

              <div>
                <h2>Booth</h2>
                <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.application_type.charAt(0).toUpperCase() + adminApplicationData.boothDetailsPayment.application_type.slice(1) : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.application_type.charAt(0).toUpperCase() + adminApplicationData.boothDetailsWithoutPayment.application_type.slice(1) : ''}</p>
                <hr/>
              </div>

              <div>
                <h2>Application Type</h2>
                <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.booth_types.name+' $'+adminApplicationData.boothDetailsPayment.booth_types.price+' USD' : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.booth_types.name+' $'+adminApplicationData.boothDetailsWithoutPayment.booth_types.price+' USD' : ''}</p>
                <hr/>
              </div>

              <div>
                <h2>Deposit</h2>
                <p>{adminApplicationData.boothDetailsPayment ? ' $'+adminApplicationData.boothDetailsPayment.booth_types.price+' USD -- PAID' : adminApplicationData.boothDetailsWithoutPayment ? ' $'+adminApplicationData.boothDetailsWithoutPayment.booth_types.price+' USD' : ''}</p>
                
                <hr/>
              </div>

              <div>
                <h2>Application Fee</h2>
                <p>$200.00 USD {adminApplicationData.boothDetailsPayment ? '-- PAID' : '' }</p>
              </div> 

            </div>
          </div> 
        </div> 


        <div className='dash-applicant'>
          <div className='row'>
            <div className='col-md-12'> 
              <h2>Are you a new applicant or returning gallery?</h2>
              <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.applicant_type==='1' ? 'New Applicant' : 'Returning Gallery' : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.applicant_type==='1' ? 'New Applicant' : 'Returning Gallery' : ''}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'> 
              <h2>Type of Artwork you are planning to exhibit?</h2>
              <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.artwork_type : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.artwork_type: ''}</p>
            </div> 
          </div>
           

          <div className='row'>
            <div className='col-md-12'> 
              <h2>Describe the history of your gallery?</h2>
              <p>{adminApplicationData.gallery_history ? adminApplicationData.gallery_history : ''}</p>
            </div>
              <h2>Intended approach / program for exhibition booth at photo l.a.?</h2>
              <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.intended_approach : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.intended_approach: ''}</p>
              <h2>Current year's gallery exhibition schedule including other Art Fair participation?</h2>
              <p>
                {adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.current_years_gallery : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.current_years_gallery: ''}
              </p>

              <h2>List of artists proposed for photo l.a. exhibition booth?</h2>
              <p>{adminApplicationData.boothDetailsPayment ? adminApplicationData.boothDetailsPayment.list_of_artists : adminApplicationData.boothDetailsWithoutPayment ? adminApplicationData.boothDetailsWithoutPayment.list_of_artists: ''}</p>
          </div>
          <hr/>
        </div>

      
        <div className='row'>
          
            {
              adminApplicationData.artworkWithPayment  ?
              adminApplicationData.artworkWithPayment.map( data => (
                <div className='col-md-6'>
                  <div className='dash-grey middle-aln'>
                    <div className='img'>
                      <img src={process.env.REACT_APP_API_STORAGE+data.images} alt="" width="100" /> 
                    </div>
                    <div className='content'>
                      <h4>{data.name}</h4>
                      <p>{data.medium}</p>
                      <p>{data.edition}</p>
                    </div>
                  </div>
                </div>
            )) :''
            }

            {
              adminApplicationData.artworkWithoutPayment ?
              adminApplicationData.artworkWithoutPayment.map( data => (
                <div className='col-md-6'>
                  <div className='dash-grey middle-aln'>
                    <div className='img'>
                      {/* <img src='images/photola-img-1.jpg' className='img-responsive' /> */}
                      <img src={process.env.REACT_APP_API_STORAGE+data.images} alt="" width="100" /> 
                    </div>
                    <div className='content'>
                      <h4>{data.name}</h4>
                      <p>{data.medium}</p>
                      {/*<p>{data.edition}</p>*/}
                    </div>
                  </div>
                </div>
            )) :''
            }
        </div>

        

        <div className='dash-sign'>
          <div className='row'>
            <div className='col-md-4 middle-aln' > 
              <h3>Applicant's Signature</h3>
            </div>

            <div className='col-md-4 sign'> 
            {adminApplicationData.termsWithPayment ? 
              <img src={adminApplicationData.termsWithPayment.signature} className='img-responsive'/>
            : adminApplicationData.termsWithoutPayment ? 
            <img src={adminApplicationData.termsWithoutPayment.signature} className='img-responsive'/>
            : '' }
            
            </div>

            <div className='col-md-4'> 
              <div className='pdf-cl middle-aln'> 
                
                {adminApplicationData.termsWithPayment ? 
                  <label onClick={(event) => handleClick(process.env.REACT_APP_STORAGE+adminApplicationData.termsWithPayment.term_pdf_path.replace('https://photola.com/photola_api/storage',''))}>
                  <img src='../images/pdf.png' className='img-responsive pdf'/>
                  <a>Terms & Conditions (PDF)</a></label>
                : adminApplicationData.termsWithoutPayment ? 
                <label onClick={(event) => handleClick(process.env.REACT_APP_STORAGE+adminApplicationData.termsWithoutPayment.term_pdf_path.replace('https://photola.com/photola_api/storage',''))}>
                  <img src='../images/pdf.png' className='img-responsive pdf'/>
                  <a>Terms & Conditions (PDF)</a>
                  </label>
                : '' }
                
              </div>
            </div>
          </div> 
        </div>

      </div> 
    </div>
  </section>  
  </>
  )
}
